import React, { forwardRef } from "react";
import "./powerPostionCard.scss";

interface Props {
  userImage: any;
  userName: string;
  userContent: React.JSX.Element;
  cardSelected: string;
  cardHandler: () => void;
  isEditMode?: boolean;
  editHandler?: () => void;
  isEditDisabled?:boolean;
}

const PowerPositionCard = forwardRef<HTMLDivElement, Props>(({
  userImage,
  userName,
  userContent,
  cardSelected,
  cardHandler,
  isEditMode = false,
  editHandler = () => {},
  isEditDisabled=false
}, ref) => {

  return (
    <div
      className={`${cardSelected !== userName &&
        cardSelected !== "" &&
        cardSelected !== null &&
        "power-position-card-not-selected"
        } power-position-card`}
      onClick={cardHandler}
      role="button"
      tabIndex={0}
    >
      {isEditMode ? <div>
        <svg xmlns="http://www.w3.org/2000/svg" onClick={editHandler} width="16" height="16" fill={isEditDisabled?"gray":"currentColor"} className="bi bi-pencil power-position-edit" viewBox="0 0 16 16">
          <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
        </svg>
      </div> : null}
      <div className="power-position-card-user-details" ref={ref} style={{ minHeight: 470 }}>
        <div className="power-position-card-user-image-box">
          <img
            src={userImage}
            alt={userName}
            className="power-position-card-user-image"
          />
        </div>
        <div className="power-position-card-user-name">{userName}</div>
        <div className="power-position-card-user-content">{userContent}</div>
      </div>
    </div>
  );
});

export default PowerPositionCard;
